export const TICKETS_URL = "https://www.skiddle.com/g/exhilaration-/";
export const LOGO_URL =
    "https://skiddlebrands.imgix.net/brands/exhilaration-_2.jpg?auto=format%2Ccompress&w=265&h=265";
export const SOCIALS = {
    instagram: "https://www.instagram.com/exhilaration.techno",
    soundcloud: "https://soundcloud.com/exhilarationtechno",
};
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
